import {headers as constantHeaders, isInterceptorActive, maxRetryCount} from "../../constants/constants";
import {store} from "../system/redux/store";
import {setIsAuthenticated} from "../system/redux/reducers/userStateReducer";
import RetryOnRequestFailInterceptor from "axios-retry";
import axios, {AxiosError} from "axios";
import API_Routes from "../../constants/api-routes";
import {setCSRFInfo} from "../system/redux/reducers/csrfReducer";
import {setUserInfo} from "../system/redux/reducers/roleReducer";
import {setMenuInfo} from "../system/redux/reducers/menuReducer";
import {setCCEmailReducer} from "../system/redux/reducers/CCEmailReducer";
import {setReloadFeedbackDetails} from "../system/redux/reducers/reloadFeedbackDetails";
import {setResponsePendingReducer} from "../system/redux/reducers/ResponsePendingReducer";
import {setNavigationData} from "../system/redux/reducers/NavigatedDataReducer";

let stateKey = null;
let keyHeader = null;
let unsubscribe = store.subscribe(()=>{
    const state = store.getState();
    console.log(state);
    stateKey = state.csrf.csrfToken;
    keyHeader = state.csrf.csrfHeaderName;
})
const {dispatch} = store;
// unsubscribe();

/**
 * Handles logging and processing of the request configuration before the request is sent.
 * Logs the request configuration to the console.
 *
 * @param {Object} config - The Axios request configuration object.
 * @returns {Object} The original Axios request configuration.
 */
const onRequest = (config) => {
    console.log("")
    config.headers = {[keyHeader]:stateKey, ...config.headers, ...constantHeaders }
    return config;
}

/**
 * Handles errors during the request phase.
 * Logs the error to the console and rejects the promise.
 * 
 * @param {AxiosError} error - The error that occurred during the request.
 * @returns {Promise} A rejected promise with the error.
 */
const onRequestError = (error) => {
    console.log(`[request error] [${JSON.stringify(error)}]`);
    return Promise.reject(error);
}

/**
 * Handles logging and processing of the response data after the response is received.
 * Logs the response to the console.
 * 
 * @param {Object} response - The Axios response object.
 * @returns {Object} The Axios response object.
 */
const onResponse = (response) => {
    if (
        response.request.responseURL.includes("/cchp-api/login")
    ) {
        const xioError = new AxiosError("Session Expired",'500', response.config, null, response);
        const sessionExpiredError = new Error("Session Expired");
        sessionExpiredError.config = response.config;
        sessionExpiredError.response = response;
        throw xioError;
    }
    return response;
}

/**
 * Handles errors that occur during the response phase.
 * Logs the error to the console and rejects the promise.
 * 
 * @param {AxiosError} error - The error that occurred during the response.
 * @returns {Promise} A rejected promise with the error.
 */
const onResponseError = (error) => {
    console.log(`[response error] [${JSON.stringify(error)}]`);
    if(error.request.responseURL.includes("/cchp-api/login")){
        const isAuthenticatedState = {
            isAuthenticated: false,
            isLoading: false,
        };
        dispatch(setIsAuthenticated(isAuthenticatedState));
    }
    return Promise.reject(error);
}

/**
 * Set up the interceptors for request and response phases.
 * Adds logging and error handling interceptors for requests and responses.
 * 
 * @param {AxiosInstance} axiosInstance - The Axios instance to add interceptors to.
 * @returns {AxiosInstance} The Axios instance with interceptors set up.
 */
export function setupInterceptorsTo(axiosInstance) {
    async function handleLogout() {
        const formData = "_csrf" + "=" + stateKey;
        await axios.post(API_Routes.logout,formData)
            .then(response => {
                console.log(response.status);
                if (response.status === 200) {
                    dispatch(setNavigationData({}));
                }
            })
        return true
    }
    function getRetryInterceptorConfig(axiosInstance) {
        const csrfValues = {
            csrfHeaderName: "X-CSRF-Token",
            csrfFormTagName: "_csrf",
            csrfToken: "",
        };
        const userData = {
            userEmail: "",
            homeLink: " ",
            roles: [],
        };

        const isAuthenticatedTemp = {
            isAuthenticated: false,
            isLoading: true,
        };

        const menuData = {
            menuItems: [],
        };
        return {
            retries: maxRetryCount,
            retryDelay: (iterationCount, error) =>
                RetryOnRequestFailInterceptor.exponentialDelay(iterationCount, error, 1000),
            retryCondition: error =>
                error.response.status === 503,
            onMaxRetryTimesExceeded: (endOfSerialError, iterationCount) => {
                handleLogout().then((response)=>{
                    const isAuthenticatedState = {
                        isAuthenticated: false,
                        isLoading: false,
                    };
                    dispatch(setIsAuthenticated(isAuthenticatedState));
                });
                
                return null;
            },
            onRetry: (iterationCount, transientError, requestConfig) => {
                console.log("We are going to retry siuuuuuuuuuuuuuuuuuuuuuuuuu");
                const fetchCSRF = async () => {
                    var signal = false
                    var tokenVal = null
                    await axiosInstance({url: API_Routes.getCSRF, method: 'GET', data: null})
                        .then(response => {

                            const contentType = response.headers["content-type"];
                            // console.log("Content Type of CSRF: " + contentType);
                            if (contentType?.includes("text/html")) {
                                fetchCSRF();
                            } else {
                                csrfValues.csrfToken = response.data;
                                tokenVal = response.data;
                                dispatch(setCSRFInfo(csrfValues));
                            }
                            signal = true;
                        })
                        .catch(error => {
                            console.error(error);
                            throw new AxiosError();
                        })
                    return {signal, tokenVal};
                }

                if(iterationCount <= maxRetryCount)
                    fetchCSRF().then(response => {
                        if(response.signal) {
                    requestConfig.headers[keyHeader] = response.tokenVal;
                }});
                return true;
            }
        }
    }

    axiosInstance.interceptors.request.use(onRequest, onRequestError);
    if(isInterceptorActive){
        const retryInterceptorConfig = getRetryInterceptorConfig(axiosInstance);
        RetryOnRequestFailInterceptor(axiosInstance,retryInterceptorConfig);
        axiosInstance.interceptors.response.use(onResponse, onResponseError);
    }
    return axiosInstance;
}
